import clsx from 'clsx'

import useHardNavigate from 'hooks/useHardNavigate'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'

import { ReactComponent as BoxIcon } from './assets/box.svg'
import { ReactComponent as CompassIcon } from './assets/compass.svg'
import { ReactComponent as EyeIcon } from './assets/eye.svg'
import { ReactComponent as GeometryIcon } from './assets/geometry.svg'
import { ReactComponent as LightbulbIcon } from './assets/light-bulb.svg'
import { ReactComponent as LinkIcon } from './assets/link.svg'
import { ReactComponent as OuterLineLeft } from './assets/outer-line-left.svg'
import { ReactComponent as OuterLineRight } from './assets/outer-line-right.svg'
import styles from './FrameworkWheel.module.scss'
import InnerCircle from './InnerCircle'
import LittleInnerCircle from './LittleInnerCircle'
import PopupDescription from './PopupDescription'
import { ReactComponent as ArrowRightIcon } from '../../assets/icons/arrow_right.svg'
export enum FrameworkWheelPage {
  Learn = 'page-learn',
  Produce = 'page-produce',
  Shape = 'page-shape',
  Create = 'page-create',
  Explore = 'page-explore',
  Assemble = 'page-assemble',
}
const navPills = [
  {
    id: FrameworkWheelPage.Produce,
    text: 'Produce',
    icon: <BoxIcon />,
    style: styles.pillGreen,
    popups: [
      {
        descriptionTitle: 'DECISION',
        description: 'Assets ready for KO Assets',
        cardTitle: 'OUTPUT',
        cardText: 'Produced Assets + Live Execution',
        left: '-400px',
        top: '-95px',
      },
    ],
    className: 'pillGreen',
    navigateTo: FrameworkWheelPage.Produce,
  },
  {
    id: FrameworkWheelPage.Shape,
    text: 'Shape',
    icon: <GeometryIcon />,
    style: styles.pillDarkYellow,
    popups: [
      {
        descriptionTitle: 'DECISION',
        description: 'Marketing XP Validation, Market Activation Plans',
        cardTitle: 'OUTPUT',
        cardText: 'Market Activation Plans',
        left: '-375px',
        top: '-90px',
        class: 'Copper',
      },
    ],
    className: 'pillDarkYellow',
    navigateTo: FrameworkWheelPage.Shape,
  },
  {
    id: FrameworkWheelPage.Create,
    text: 'Create',
    icon: <LightbulbIcon />,
    style: styles.pillCopper,
    popups: [
      {
        descriptionTitle: 'DECISION',
        description: 'Selected ideas/experiences & topline plan on production',
        cardTitle: 'OUTPUT',
        cardText: 'Scaled Experiences & Ideas Bank, 2y+ Roadmap',
        top: '-150px',
        left: '-523px',
      },
      {
        descriptionTitle: 'DECISION',
        description: 'Creative Strategy BBEI Sign-off',
        cardTitle: 'OUTPUT',
        cardText: 'BBEEI & POCs, XP Architecture',
        top: '-150px',
        left: '300px',
      },
    ],
    className: 'pillCopper',
    navigateTo: FrameworkWheelPage.Create,
  },
  {
    id: FrameworkWheelPage.Explore,
    text: 'Explore',
    icon: <CompassIcon />,
    style: styles.pillOrange,
    popups: [
      {
        descriptionTitle: 'DECISION',
        description: 'Strategy & Brief Sign-off',
        cardTitle: 'OUTPUT',
        cardText: 'OneBrief',
        top: '-95px',
        left: '150px',
      },
    ],
    className: 'pillOrange',
    navigateTo: FrameworkWheelPage.Explore,
  },
  {
    id: FrameworkWheelPage.Assemble,
    text: 'Assemble',
    icon: <LinkIcon />,
    style: styles.pillRed,
    popups: [
      {
        descriptionTitle: 'DECISION',
        description: 'Project Plan, Team',
        cardTitle: 'OUTPUT',
        cardText: 'Project Blueprint',
        top: '-98px',
        left: '195px',
      },
    ],
    className: 'pillRed',
    navigateTo: FrameworkWheelPage.Assemble,
  },
]
interface FrameworkWheelProps {
  active?: FrameworkWheelPage
}

interface FrameworkWheelProps {
  active?: FrameworkWheelPage
}
const FrameworkWheel = ({ active }: FrameworkWheelProps) => {
  const hardNavigate = useHardNavigate()
  return (
    <div className={clsx(styles.FrameworkWheel, active && styles.active)}>
      <div className={styles.outerCircle}>
        <div className={styles.outerLineMask}>
          <div className={styles.outerLineLeft}>
            <div
              className={clsx(
                styles.navPillContainer,
                styles.pillBlue,
                active === FrameworkWheelPage.Learn && styles.active,
              )}
            >
              <div
                className={styles.navPill}
                onClick={() => {
                  hardNavigate(FrameworkWheelPage.Learn)
                  trackAnalytics({
                    type: AnalyticsActionType.action,
                    payload: EVENTS.ACTION.FRAMEWORK('learn'),
                  })
                }}
              >
                <div className={styles.text}>Learn</div>
                <div className={styles.iconContainer}>
                  <div className={clsx(styles.icon, styles.hideOnHover)}>
                    <EyeIcon />
                  </div>
                  <div className={clsx(styles.icon, styles.showOnHover)}>
                    <ArrowRightIcon />
                  </div>
                </div>
              </div>
              {!active?.length && (
                <div className={styles.showOnHover}>
                  <PopupDescription
                    cardTitle="INPUT"
                    cardText="Learnings from previous charters, LRP/BP, BVA, Persistent Platform"
                    left="-395px"
                    top="-175px"
                    className="pillBlue"
                  />
                  <PopupDescription
                    descriptionTitle="DECISION"
                    description="Stop/Continue/Iterate"
                    cardTitle="OUTPUT"
                    cardText="Key Learnings"
                    left="385px"
                    top="-81px"
                    className="pillBlue"
                  />
                </div>
              )}
            </div>
            <OuterLineLeft />
          </div>
          <div className={styles.outerLineRight}>
            <OuterLineRight />
          </div>
        </div>
        <div className={clsx(styles.outerCircleMask, active === FrameworkWheelPage.Learn && styles.active)} />
        <div className={styles.innerCircle}>
          <div className={styles.innerCircleMask}>
            {navPills.map((pill, index) => (
              <div
                key={index}
                className={clsx(styles.navPillContainer, pill.style, active === pill.id && styles.active)}
              >
                <div
                  className={clsx(styles.navPill)}
                  onClick={() => {
                    hardNavigate(pill.navigateTo)
                    trackAnalytics({
                      type: AnalyticsActionType.action,
                      payload: EVENTS.ACTION.FRAMEWORK(pill.text.toLowerCase()),
                    })
                  }}
                >
                  <div className={styles.text}>{pill.text}</div>
                  <div className={styles.iconContainer}>
                    <div className={clsx(styles.icon, styles.hideOnHover)}>{pill.icon}</div>
                    <div className={clsx(styles.icon, styles.showOnHover)}>
                      <ArrowRightIcon />
                    </div>
                  </div>
                </div>
                <div className={styles.showOnHover}>
                  {!active?.length &&
                    pill.popups?.map((popup, index) => (
                      <div key={index}>
                        <PopupDescription
                          descriptionTitle={popup.descriptionTitle}
                          description={popup.description}
                          cardTitle={popup.cardTitle}
                          cardText={popup.cardText}
                          left={popup.left}
                          top={popup.top}
                          className={pill.className}
                        />
                      </div>
                    ))}
                </div>
              </div>
            ))}
            {active?.length ? <LittleInnerCircle active={active} /> : <InnerCircle />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FrameworkWheel
